{
  "sdk-download-android": "Android için indir",
  "sdk-connect": "Bağlan",
  "sdk-download-ios": "iOS için indir",
  "sdk-install": "Yükle",
  "sdk-modal-instruct-1": "1. Binance Uygulamasını Açın",
  "sdk-modal-instruct-2": "2. Ana Ekranda {{icon}} simgesine dokunun",
  "sdk-modal-title": "Binance ile Bağlanın",
  "sdk-no-app": "Henüz Binance uygulamanız yok mu?"
}